import { createStyles } from '@material-ui/core'
//import background from 'img/bg-login-pattern-icons.png'
// import background from 'img/bg-eris.png'
import background from 'img/bg-eris1.jpg'

const styles = () =>
  createStyles({
    side: {
      gridArea: 'side',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      background: `rgba(20, 38, 48, 1) url(${background}) top left`,
      color: '#fff',
      overflow: 'hidden',
      textAlign: 'center',
      padding: '1rem 3rem 2rem 3rem',
      '& button, footer p, h2, a, header a': {
        fontFamily: 'brandon-grotesque, "Open Sans", open-sans, sans-serif',
      },
      '& .content h2': {
        marginBottom: '33px',
        opacity: '.89',
        fontWeight: 600,
        fontSize: '20px',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
      },
      '& .content h2 small': {
        display: 'block',
        marginBottom: '17px',
        fontSize: '12px',
        letterSpacing: '1px',
      },
      '& .content p': {
        marginBottom: '35px',
        opacity: '.7',
        fontStyle: 'italic',
        fontSize: '15px',
        lineHeight: '25px',
      },
      '& .content a': {
        display: 'inline-block',
        border: '2px solid rgb(248, 194, 81)',
        borderRadius: '100px',
        fontSize: '10px',
        fontWeight: 700,
        color: 'rgb(248, 194, 81)',
        letterSpacing: '1px',
        padding: '0 36px',
        height: '36px',
        lineHeight: '36px',
        textDecoration: 'none',
        textTransform: 'uppercase',
      },
      '& .footer p': {
        marginBottom: '28px',
        opacity: '.39',
        fontSize: '11px',
        textTransform: 'uppercase',
        color: '#FFF',
        letterSpacing: '.91px',
      },
      '& .footer img': {
        maxWidth: '100%',
      },
    },
    header: {
      width: '160px',
      // height: '80px',
      color: 'transparent',
    },
  })

export default styles
